<template>
  <div class="orderPage">
    <div class="search_wrap flex-between">
      <van-field v-model="params.order_id" placeholder="输入订单号查找→" />
      <div class="search_btn flex-rowc" @click="handleSearch">
        <i class="iconfont icon-chazhaotubiao"></i>
      </div>
    </div>

    <div class="order_wrap" @scroll="orderScroll($event)">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="list" v-if="dataList.length > 0">
          <div
            class="item"
            v-for="item in dataList"
            :key="item.id"
            @click="handleDetail(item.order_id)"
          >
            <div class="block_one">
              <div class="column flex-rowl">
                <p class="label">创建时间：</p>
                <p class="con">{{ getTiemSplit(item.create_time) }}</p>
              </div>
              <div class="column flex-rowl">
                <p class="label">订单状态：</p>
                <p class="con">
                  {{ item.service_order_statusstr }}
                </p>
              </div>
              <div class="column flex-rowl">
                <p class="label">订单情况：</p>
                <p class="con">
                  {{
                    item.service_order_property == 1
                      ? "服务订单进行中"
                      : item.service_order_property == 2
                      ? "服务订单取消申请中"
                      : item.service_order_property == 3
                      ? "服务订单已取消"
                      : "服务订单已完成"
                  }}
                </p>
              </div>
            </div>
            <div class="block_two">
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label">服务订单号：</p>
                  <p class="con">
                    {{ item.service_order_id }}
                  </p>
                </div>
                <div
                  class="btn_copy code flex-rowr"
                  @click.stop="customCopy(item.service_order_id)"
                >
                  <i class="iconfont icon-fuzhi"></i>
                </div>
              </div>
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label">订单号：</p>
                  <p class="con">
                    {{ item.order_id }}
                  </p>
                </div>
                <div
                  class="btn_copy code flex-rowr"
                  @click.stop="customCopy(item.service_order_id)"
                >
                  <i class="iconfont icon-fuzhi"></i>
                </div>
              </div>
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label">餐厅名称：</p>
                  <p class="con">
                    {{ item.shop_name }}
                  </p>
                </div>
              </div>
              <div class="column flex-rowl">
                <p class="label">送餐位置：</p>
                <p class="con">{{ item.address_detail }}</p>
              </div>
              <div class="column flex-rowl">
                <p class="label">送餐楼栋：</p>
                <p class="con">{{ item.buildingidstr }}</p>
              </div>
              <div class="column flex-rowl">
                <p class="label">关联取餐柜：</p>
                <p class="con">{{ item.service_rating }}</p>
              </div>
              <div class="column flex-rowl">
                <p class="label">用户姓名：</p>
                <p class="con">{{ item.truename }}</p>
              </div>
              <div class="column flex-rowl">
                <p class="label">联系电话：</p>
                <p class="con">{{ item.customer_phone }}</p>
              </div>
              <div class="column order_content flex-rowl">
                <p class="label">订单内容：</p>
                <p class="con">{{ item.order_content }}</p>
              </div>
            </div>
          </div>
        </div>
        <van-empty
          description="暂无订单"
          v-if="!isLoading && dataList.length == 0"
        />
      </van-pull-refresh>

      <div class="custom_btn" @click="handleReturn">返回</div>
    </div>
  </div>
</template>

<script>
import { getOrderList, orderSendManage, getToken } from "../../api/api";
export default {
  name: "tOrderList",
  data() {
    return {
      // role 职能身份  "1","综合服务人员"|"2","取餐员"|"3","送餐员"|"4","点位服务人员"|"5","派单管理员"
      show: false,
      // 服务订单状态
      serviceOrderState: [
        {
          text: "所有状态订单",
          value: "",
        },
        {
          text: "待接单",
          value: 1,
        },
        {
          text: "已接单",
          value: 2,
        },
        {
          text: "已取餐",
          value: 3,
        },
        {
          text: "送餐中",
          value: 4,
        },
        {
          text: "待自提（已放入餐柜）",
          value: 5,
        },
        {
          text: "已送达（直达/或送至自提点）",
          value: 6,
        },
        {
          text: "已完成",
          value: 7,
        },
      ],
      // 服务订单属性
      serviceOrderProperty: [
        {
          text: "所有情况订单",
          value: "",
        },
        {
          text: "服务订单进行中",
          value: 1,
        },
        {
          text: "服务订单已取消（已退款）",
          value: 2,
        },
        {
          text: "服务订单已取消",
          value: 3,
        },
        {
          text: "服务订单已完成",
          value: 4,
        },
      ],

      checked: true,
      orderType: 1,
      orserState: "所有状态订单",
      orderProperty: "所有情况订单",
      params: {
        Page: 1,
        token: "",
        PageSize: 20,
        order_id: "",
        service_order_status: "",
        service_order_property: "",
        // istoday: 1, // 1 是 0 否
        phoneend: "",
      },

      isLoading: true,
      total: 0,
      dataList: [],

      dept: "",
      userInfo: "",
      type: "", // 1-接单、2-取餐、3-送餐、4-分派处理
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    this.userInfo = userInfo;
    let { phoneend, type } = this.$route.params;
    this.params.phoneend = phoneend;
    // this.params.service_order_status = type == 3 ? '2,3' : type;
    this.type = type;
    if (userInfo.dept.length > 0) {
      this.dept = userInfo.dept[0];
    }
    this.getToken();
  },
  computed: {
    getTiemSplit() {
      return function (data) {
        // let newData = data.split('T')[0] + ' ' + data.split('T')[1]
        let newData = data.replace("T", " ");
        return newData;
      };
    },
  },
  methods: {
    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.params.token = res.data.token;
          this.getOrderList();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },
    onRefresh() {
      this.params.Page = 1;
      this.getOrderList(true);
    },
    //
    getOrderList(isRefresh) {
      let { params } = this;
      getOrderList(params).then((res) => {
        if (res.error_code == 0) {
          if (isRefresh) {
            this.dataList = [];
          }
          this.total = res.data.total;
          res.data.list.forEach((item) => {
            const items = item.order_content.split(",");
            item.orderContent = items.map((item) => ({
              name: item,
              isDispatched: false,
            }));
          });
          this.dataList = this.dataList.concat(...res.data.list);
          this.isLoading = false;
        } else {
          this.dataList = [];
        }
      });
    },

    // 滚动事件
    orderScroll(e) {
      let el = e.target;
      //判断是否到达div容器底部
      let { total, dataList } = this;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        // if (listTotal > dataList.length) {
        //   this.params.Page += 1;
        //   this.initData();
        // }
        if (total > dataList.length) {
          this.params.Page += 1;
          this.getOrderList();
        }
      }
    },
    handleShow(type) {
      this.orderType = type;
      this.show = true;
    },
    handleSearch() {
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeCheck(e) {
      this.params.istoday = e ? 1 : 0;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeDropdownStatus(e) {
      console.log(e, "=========");
      this.params.service_order_status = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeDropdownProperty(e) {
      console.log(e, "=========");
      this.params.service_order_property = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    // onConfirmState(e) {
    //   let { text, value } = e;
    //   this.orserState = text;
    //   this.params.service_order_status = value;
    //   this.show = false;
    //   this.params.Page = 1;
    //   this.dataList = [];
    //   this.getOrderList();
    // },
    // onConfirmProperty(e) {
    //   let { text, value } = e;
    //   this.orderProperty = text;
    //   this.params.service_order_property = value;
    //   this.show = false;
    //   this.params.Page = 1;
    //   this.dataList = [];
    //   this.getOrderList();
    // },
    handleClearParams() {
      this.params.order_id = "";
      this.params.service_order_status = "";
      this.params.service_order_property = "";
      (this.orserState = "所有状态订单"),
        (this.orderProperty = "所有情况订单"),
        (this.params.istoday = 0);
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    /**
     * 自定义复制功能
     * @param {string} text - 需要复制的文本
     */
    async customCopy(text) {
      try {
        // 检查浏览器是否支持 Clipboard API
        if (navigator.clipboard) {
          // 调用 Clipboard API 进行复制
          await navigator.clipboard.writeText(text);
          this.$toast({
            message: "复制成功",
          });
        } else {
          // 不支持 Clipboard API 时的降级处理
          const textarea = document.createElement("textarea");
          textarea.value = text;
          textarea.style.position = "absolute";
          textarea.style.left = "-9999px";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
          this.$toast({
            message: "复制成功",
          });
        }
      } catch (error) {
        this.$toast({
          message: "复制失败，请稍后重试",
        });
        console.error("复制失败:", error);
      }
    },
    handleDetail(orderNo) {
      let { type } = this;
      if (type == 1) {
        this.$router.push(`/tekeOrder/tOrderIndex/${orderNo}`);
      } else if (type == 2) {
        this.$router.push(`/tekeMeal/tMealIndex/${orderNo}/${true}`);
      } else if (type == 3) {
        this.$router.push(`/dispatch/dIndex/${orderNo}`);
        // this.$router.push(`/sendMeal/sMealIndex/${orderNo}`);
      } else if (type == 4) {
        // this.$router.push(`/dispatch/dIndex/${orderNo}`);
      }
    },

    // 触发接单事件
    handleOrder(state, order_id) {
      // state=2 已接单
      let that = this;
      if (state == 2) return;
      this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
        loadingType: "spinner",
      });
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          orderSendManage({
            token: res.data.token,
            order_id,
            get_staff_id: this.userInfo.openid,
          }).then((res1) => {
            if (res1.error_code == 0) {
              this.$toast.success("接单成功");
              this.params.token = res.data.token;
              setTimeout(() => {
                this.params.Page = 1;
                that.getOrderList(true);
              }, 800);
            } else {
              this.$toast.fail(res.message || "接口失效，请稍后～");
            }
          });
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
      console.log(order_id, "-----未接单");
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang='less' scoped>
.orderPage {
  padding-top: 40px;
  .search_wrap {
    width: 660px;
    height: 80px;
    border: 1px solid rgba(173, 173, 173, 0.76);
    border-radius: 45px;
    margin: auto;
    background: #ffffff;
    padding: 0 20px;
    box-sizing: border-box;
    margin-bottom: 25px;
    /deep/ .van-cell {
      padding: 0;
      background: none;
      flex-shrink: 0;
      border: none;
      flex: 1;
    }
    /deep/ .van-field__control {
      text-align: center;
    }
    .search_btn {
      flex-shrink: 0;
      width: 70px;
      .iconfont {
        font-size: 40px;
        color: #d6d0d1;
      }
    }
  }
  .select_wrap {
    width: 660px;
    margin: auto;
    .select_item {
      margin-top: 20px;
      height: 80px;
      border-bottom: 1px dashed #2c2b2b;
      font-size: 30px;
      color: #333333;
      padding: 0 14px;
      .icon-toTop {
        transform: rotate(180deg);
        font-size: 20px;
      }
    }
    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
    }
    /deep/ .van-dropdown-menu__title {
      width: 280px;
      box-sizing: border-box;
      text-align: center;
      padding: 0 30px 0 15px;
    }
    /deep/ .van-dropdown-menu__title::after {
      right: 20px;
      border-color: transparent transparent #c4c5c6 #c4c5c6;
    }
  }
  .radio_wrap {
    font-size: 24px;
    color: #1e1e1e;
    margin: 25px auto;
    span {
      margin-left: 16px;
    }
  }
  .clear_condition {
    width: 200px;
    height: 60px;
    background: #ffffff;
    border: 3px solid #096f70;
    border-radius: 35px;
    margin: auto;
    font-size: 24px;
    color: #096f70;
    text-align: center;
    line-height: 60px;
  }
  .order_wrap {
    margin-top: 25px;
    height: 86vh;
    overflow-y: scroll;
    .list {
      .item {
        width: 660px;
        min-height: 700px;
        background: #ffffff;
        border: 6px solid #e6e6e6;
        border-radius: 40px;
        margin: 0 auto 30px;
        padding: 52px 44px;
        box-sizing: border-box;
        font-size: 28px;
        color: #040000;
        .block_one {
          font-size: 30px;
          margin-bottom: 45px;
          .column {
            &:nth-child(2n) {
              margin: 10px 0;
            }
            .label {
              width: 140px;
            }
            .con {
              color: #ff0000;
            }
          }
        }
        .block_two {
          // margin-bottom: 99px;
          font-size: 28px;
          position: relative;
          .column {
            &:last-child {
              margin-bottom: 0;
            }
          }
          .order_state_operation {
            position: absolute;
            bottom: 0;
            right: -30px;
            .btn {
              width: 130px;
              height: 40px;
              background: #096f70;
              border-radius: 45px;
              text-align: center;
              font-size: 20px;
              color: #fff;
              &.disabled {
                background: #9e9e9e;
              }
            }
          }
        }

        .column {
          align-items: flex-start;
          width: 100%;
          &:nth-child(2n) {
            margin: 26px 0;
          }
          .left {
            flex: 1;
            align-items: flex-start;
            flex-wrap: wrap;
            .con {
              width: 320px;
              flex-shrink: 0;
            }
          }
          .label {
            white-space: nowrap;
            width: 170px;
            flex-shrink: 0;
          }
          .con {
            word-wrap: break-word;
            flex-shrink: 0;
            width: 380px;
            span {
              margin-left: 10px;
            }
          }
          .btn_copy {
            width: 40px;
            flex-shrink: 0;
            .iconfont {
              font-size: 30px;
            }
          }
          &.order_content {
            flex: 1;
            .con {
              flex-shrink: 0;
            }
            .column-list {
              margin: 20px 0 30px;
              .column-item {
                font-size: 24px;
                margin-bottom: 30px;
                &:last-child {
                  margin-bottom: 0;
                }
                .txt {
                  line-height: 28px;
                }
                .state {
                  flex-shrink: 0;
                  margin-left: 40px;
                  width: 130px;
                  height: 40px;
                  border-radius: 50px;
                  background: #096f70;
                  color: #fff;
                  font-size: 22px;
                  &.disabled {
                    background: #9e9e9e;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  /deep/ .van-popup--bottom {
    bottom: 80px;
  }
  .custom_btn {
    margin-top: 30px;
  }
}
</style>